module.exports = __webpack_public_path__ + "media/buy-now/bag5-27a94b26.png";